import axios from "axios";
import { API_ROOT } from "./api";

const staffApi = axios.create({ baseURL: API_ROOT, withCredentials: true });

export default staffApi;
